export const LIST_ID_OVERVIEW = "overview";

export const defaultErrors = {
    DUPLICATE_KEY: "workspace.websites.modal.error.duplicate.key",
    DUPLICATE_KEYS: "workspace.websites.modal.error.duplicate.keys",
    SERVER_ERROR: "workspace.websites.modal.error.server",
    EXCEED_ALLOWED_QUOTAS: "workspace.websites.modal.error.exceed.allowed.quotas",
};
